import { MAX_OUTPUT_WIDTH, MIN_OUTPUT_WIDTH } from '../constants'
import { removeTransparency } from './image-data-utils'

/**
 * Returns a copy of a canvas scaled to fit min/max dimensions and no semi-transparent pixels.
 */
const getUploadCanvas = (canvas: HTMLCanvasElement): HTMLCanvasElement => {
    const outputCanvas = document.createElement('canvas')
    const outputContext = outputCanvas.getContext('2d')
    const context = canvas.getContext('2d')

    if (context && outputContext) {
        // scale the output canvas to fit in our min/max output size
        outputCanvas.width = Math.max(Math.min(canvas.width, MAX_OUTPUT_WIDTH), MIN_OUTPUT_WIDTH)
        outputCanvas.height = outputCanvas.width / (canvas.width / canvas.height)

        // draw scaled canvas
        outputContext.drawImage(canvas, 0, 0, outputCanvas.width, outputCanvas.height)

        // get image data
        const imageData = outputContext.getImageData(0, 0, outputCanvas.width, outputCanvas.height)

        // remove semi-transparent pixels
        outputContext.putImageData(removeTransparency(imageData), 0, 0)

        return outputCanvas
    }

    return canvas
}

export default getUploadCanvas
